import { Input, Select, Tabs } from '@mantine/core';
import Header from 'components/Header';
import React, { useState } from 'react';

import { ReactComponent as SearchIcon } from 'assets/icons/searchIcon.svg';
import { ReactComponent as FilterIcon } from 'assets/icons/filterIcon.svg';
import { ReactComponent as DownArrowIcon } from 'assets/icons/downArrow.svg';
import PrimaryButton from 'components/primaryButton';
import MyStories from './components/mystories';
import AddNewStroryEmployeeModal from './components/addnewBlogemployee';
import DraftStories from './components/draftstories';
import DeletedBlogStories from './components/deletedblogstories';
import useGetemployeeblogs from './hooks/usegetemployeeblogdata';
import dayjs from 'dayjs';

export default function EmployeeBlog() {
  // const [activeTab, setActiveTab] = useState(0);
  const [newStoryModal, setNewStoryModal] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [filterYear, setFilterYear] = useState('');

  // const employeeData = useGetemployeeblogs({
  //   BlogId: '',
  // });
  const employeeBlogData = useGetemployeeblogs({
    searchText: searchText,
    filterYear: filterYear,
  });

  //  filtering the years for created stories
  var dates = employeeBlogData?.data?.data?.map((story) =>
    dayjs(story.created_date).format('YYYY')
  );

  var years = [];
  if (dates) {
    dates.forEach((date) => {
      if (years.indexOf(date) === -1) {
        years.push(date);
      }
    });
  }
  if (years.length === 0) {
    years.push({
      value: 'no data',
      label: 'No data',
      disabled: true,
    });
  } else {
    years = years.sort();
  }
  return (
    <>
      <div className='px-5'>
        <div className='flex justify-between items-center mt-6'>
          <p className='text-xl text-A8A8A8'>
            {/* Calendar &#60;{' '}
            <span className='text-gray font-semibold'> Leaves & Holidays</span> */}
            Submit a story
          </p>
          <Header />
        </div>
        <div className='mt-8'>
          <div className='mt-8 relative'>
            <div>
              <Tabs
                tabPadding={21}
                // onTabChange={setActiveTab}
                classNames={{
                  tabsListWrapper: 'border-0',
                  tabActive: 'border-2 border-primary font-semibold text-18',
                  tabControl: 'text-A8A8A8 leading-5 px-0 mr-4',
                  tabLabel: 'text-18 text-gray',
                }}
              >
                <Tabs.Tab label='My stories'>
                  <MyStories searchText={searchText} filterYear={filterYear} />
                </Tabs.Tab>
                <Tabs.Tab label='Drafts'>
                  <DraftStories
                    searchText={searchText}
                    filterYear={filterYear}
                  />
                </Tabs.Tab>
                <Tabs.Tab label='Deleted stories'>
                  <DeletedBlogStories
                    searchText={searchText}
                    filterYear={filterYear}
                  />
                </Tabs.Tab>
              </Tabs>
            </div>
            {/* Search  */}
            <div className='absolute top-2 right-0 flex items-center gap-3'>
              <Input
                icon={<SearchIcon />}
                placeholder='Search'
                value={searchText}
                onChange={(e) => {
                  setSearchText(e.target.value);
                }}
                classNames={{
                  wrapper: 'border-primary border-b',
                  input: 'w-48  bg-light-bg border-none',
                }}
                // rightSection={
                //   <Loader
                //     size='xs'
                //     className={`${
                //       searchText && employeeData.isLoading
                //         ? 'visible'
                //         : 'invisible'
                //     }`}
                //   />
                // }
              />
              <Select
                data={years}
                //   value={selectEvent}
                //   onChange={(event) => setSelectEvent(event)}
                icon={<FilterIcon />}
                rightSection={<DownArrowIcon />}
                value={filterYear}
                onChange={setFilterYear}
                className='w-40'
                classNames={{
                  rightSection: 'pointer-events-none',
                  wrapper: 'border-primary border-b',
                  input: '  bg-light-bg border-none',
                }}
              />
              {employeeBlogData?.data?.data.length === 0 ? null : (
                <button onClick={() => setNewStoryModal(true)}>
                  <PrimaryButton>Add a story</PrimaryButton>
                </button>
              )}
            </div>
          </div>{' '}
        </div>
      </div>
      <AddNewStroryEmployeeModal
        newStoryModal={newStoryModal}
        setNewStoryModal={setNewStoryModal}
      />
    </>
  );
}
